import { render, staticRenderFns } from "./TablaNoSeriada.vue?vue&type=template&id=368342f4&"
import script from "./TablaNoSeriada.vue?vue&type=script&lang=ts&"
export * from "./TablaNoSeriada.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('368342f4', component.options)
    } else {
      api.reload('368342f4', component.options)
    }
    module.hot.accept("./TablaNoSeriada.vue?vue&type=template&id=368342f4&", function () {
      api.rerender('368342f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MovimientoDispositivos/TablaNoSeriada.vue"
export default component.exports